(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6496],{

/***/ 94325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/shipping-and-delivery",
      function () {
        return __webpack_require__(95317);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42031);



var ShippingAndDeliveryPolicyPage = function() {
    var companyName = "https://anthu.vn";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "CH\xcdNH S\xc1CH VẬN CHUYỂN - GIAO NHẬN",
                description: "CH\xcdNH S\xc1CH VẬN CHUYỂN - GIAO NHẬN"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-gap-y-1 tw-flex-col tw-leading-7",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase",
                            children: "CH\xcdNH S\xc1CH VẬN CHUYỂN - GIAO NHẬN"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-leading-7 tw-flex tw-flex-col tw-gap-y-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold",
                                    children: "1. Giao h\xe0ng trong nước:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "tw-font-semibold",
                                    children: "* Tại Tp.HCM:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Phương thức giao h\xe0ng: giao trực tiếp bởi nh\xe2n vi\xean An Thư sau khi đơn h\xe0ng được xử l\xfd v\xe0 th\xf4ng b\xe1o cho Kh\xe1ch H\xe0ng trước khi giao."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- H\xecnh thức thanh to\xe1n: thanh to\xe1n ngay khi nhận h\xe0ng bằng tiền mặt hoặc chuyển khoản (chỉ giao h\xe0ng khi đ\xe3 nhận cọc trước đ\xf3 tối thiểu 10%)."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Trường hợp ph\xe1t sinh chậm trễ hoặc chuyển đổi h\xecnh thức giao h\xe0ng: nh\xe2n vi\xean An Thư sẽ th\xf4ng b\xe1o trước với Kh\xe1ch H\xe0ng."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Ph\xed giao h\xe0ng: miễn ph\xed."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "tw-font-semibold",
                                    children: " * C\xe1c Tỉnh th\xe0nh kh\xe1c:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Phương thức giao h\xe0ng: th\xf4ng qua đơn vị vận chuyển uy t\xedn."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                "- H\xecnh thức thanh to\xe1n: thanh to\xe1n đủ 100% gi\xe1 trị đơn h\xe0ng trước khi An Thư chuyển giao đơn h\xe0ng cho đơn vị vận chuyển.",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                "- Trường hợp ph\xe1t sinh chậm trễ hoặc chuyển đổi h\xecnh thức giao h\xe0ng: nh\xe2n vi\xean An Thư sẽ th\xf4ng b\xe1o trước với Kh\xe1ch H\xe0ng.",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Ph\xed giao h\xe0ng: miễn ph\xed ."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-leading-7 tw-flex tw-flex-col tw-gap-y-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold",
                                    children: "2. Vận chuyển quốc tế: "
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Phương thức giao h\xe0ng: th\xf4ng qua đơn vị vận chuyển uy t\xedn."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- H\xecnh thức thanh to\xe1n: thanh to\xe1n đủ 100% gi\xe1 trị đơn h\xe0ng trước khi An Thư chuyển giao đơn h\xe0ng cho đơn vị vận chuyển."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Trường hợp ph\xe1t sinh chậm trễ hoặc chuyển đổi h\xecnh thức giao h\xe0ng: nh\xe2n vi\xean An Thư sẽ th\xf4ng b\xe1o trước với Kh\xe1ch H\xe0ng."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Ph\xed giao h\xe0ng: theo biểu ph\xed của đơn vị vận chuyển cho từng quốc gia."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-leading-7 tw-flex tw-flex-col tw-gap-y-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold",
                                    children: "2. Cam kết: "
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Đơn h\xe0ng của Kh\xe1ch H\xe0ng th\xf4ng qua đơn vị vận chuyển đều c\xf3 bảo hiểm đền b\xf9 v\xec vậy chỉ giao h\xe0ng đ\xfang ch\xednh chủ."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- Đơn h\xe0ng của Kh\xe1ch H\xe0ng do nh\xe2n vi\xean An Thư vận chuyển sẽ giao h\xe0ng đ\xfang ch\xednh chủ hoặc người được Kh\xe1ch H\xe0ng ủy quyền, chỉ định."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "- An Thư chịu tr\xe1ch nhiệm đảm bảo cho Kh\xe1ch H\xe0ng nhận h\xe0ng đ\xfang quy c\xe1ch như khi mua trực tiếp tại cửa h\xe0ng."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShippingAndDeliveryPolicyPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(94325); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);